<script>
import axios from 'axios';
import { cmsUrl } from '../variables';
import LoadIndicator from '../components/LoadIndicator';

export default {
    name: 'ProjectForm',
    components: {
        LoadIndicator,
    },
    data() {
        return {
            offeringId: null,
            offeringData: { page_title: '', description: '', link: '' },
            isLoading: false,
            isSaving: false,
            sendError: false,
            errors: [],
        }
    },
    mounted() {
        this.offeringId = this.$route.params.offeringId ? this.$route.params.offeringId : null;
        if (this.offeringId)
            this.init(this.offeringId)
    },
    methods: {
        init(id) {
            this.isLoading = true;
            axios
                .get(cmsUrl + '/organisations/post?id=' + id)
                .then(this.onDataLoaded)
                .catch(() => this.onError())
        },
        onDataLoaded(data) {
            if (!data || !data.data) {
                this.onError();
                return;
            }
            this.offeringData = data.data;
            this.isLoading = false;
        },
        onError() {
            this.isLoading = false;
        },
        onSubmit(e) {
            e.preventDefault();
            if (this.isSaving) return;
            
            this.errors = [];
            if (!this.offeringData.post_title)
                this.errors.push({concern: 'title', msg: this.$t('projectForm.filedValidationMsgTitle')});
            if (!/^(http|https):\/\/[^ "]+$/.test(this.offeringData.link))
                this.errors.push({concern: 'link', msg: this.$t('projectForm.filedValidationMsgLink')});
            if (this.errors.length > 0) {
                this.scrollToFormTop();
                return;
            }
            
            this.isSaving = true;
            this.sendError = false;
            axios
                .post(cmsUrl + '/organisations/post', {
                    id: this.offeringId,
                    organisation_id: this.$route.params.organisationId,
                    title: this.offeringData.post_title,
                    description: this.offeringData.description,
                    link: this.offeringData.link,
                    type: 'project',
                },
                {
                    headers: { }
                })
                .then(() => {
                    this.isSaving = false;
                    this.$router.push('/organisation/' + this.$route.params.organisationId);
                })
                .catch(() => {
                    this.isSaving = false;
                    this.sendError = true;
                    this.scrollToFormTop();
                })
            
        },
        onCancel(e) {
            e.preventDefault();
            this.$router.push('/organisation/' + this.$route.params.organisationId);
        },
        scrollToFormTop() {
            setTimeout(() => {
                window.scrollTo(0, this.$refs.form.offsetTop - 100);
            }, 100)
        },
    },
    computed: {
        routerKey() {
            return this.$route.path;
        },
    },
};
</script>

<template>
    <section class="project-form">
        <h1 class="project-form__title page-title">
            <span v-if="$route.params.offeringId">{{$t('projectForm.titleEdit')}}</span>
            <span v-if="!$route.params.offeringId">{{$t('projectForm.titleCreate')}}</span>
        </h1>

        <form ref="form" action="" class="project-form__form" v-if="!isLoading">
            <div class="project-form__error">
                <h2 class="project-form__error-title" v-if="errors.length > 0">{{$t('projectForm.formValidationError')}}</h2>
                <h2 class="project-form__error-title" v-if="sendError">{{$t('projectForm.sendError')}}</h2>
            </div>

            <div class="project-form__input-group form-control">
                <label class="project-form__label form-control__label" for="">{{$t('projectForm.inputLabelTitle')}}</label>
                <input class="project-form__control form-control__input" type="text" name="title" v-model="offeringData.post_title">
                <div class="project-form__error-msg" v-if="errors.find(item => item.concern === 'title')">{{errors.find(item => item.concern === 'title').msg}}</div>
            </div>

            <div class="project-form__input-group form-control">
                <label class="project-form__label form-control__label" for="">{{$t('projectForm.inputLabelDescription')}}</label>
                <textarea class="project-form__control form-control__input" name="description" rows="3" v-model="offeringData.description"></textarea>
            </div>

            <div class="project-form__input-group form-control">
                <label class="project-form__label form-control__label" for="">{{$t('projectForm.inputLabelLink')}}</label>
                <input class="project-form__control form-control__input" type="text" name="link" v-model="offeringData.link" placeholder="https://domain.ch">
                <div class="project-form__error-msg" v-if="errors.find(item => item.concern === 'link')">{{errors.find(item => item.concern === 'link').msg}}</div>
            </div>

            <p class="project-form__draft-note" v-if="!$route.params.offeringId">{{$t('projectForm.draftNote')}}</p>

            <div class="project-form__actions">
                <button class="button button--primary" v-on:click="onSubmit($event)"><span v-if="!isSaving">{{$t('projectForm.buttonSave')}}</span><span v-if="isSaving">{{$t('projectForm.loading')}}</span></button>
                <button class="button button--secondary" v-on:click="onCancel($event)">{{$t('projectForm.buttonCancel')}}</button>
            </div>
        </form>
        <load-indicator v-if="isLoading" />
    </section>
</template>

<style lang="scss" scoped>
.project-form__actions {
    margin-top: 8rem;
}
.project-form__draft-note {
    max-width: 41.6rem;
    margin:  6.4rem 0 -3.2rem;
}
.project-form__error-title {
    margin-bottom: 4rem;
    font-weight: 300;
    font-size: 2rem;
    color: $color-danger;
}
.project-form__error-msg {
    margin: -1.6rem 0 2.4rem;
    font-size: 1.44rem;
    color: $color-danger;
}
</style>
